import { useEffect } from 'react';
import MobileInput from './MobileInput';
import TandCInputPreview from './TandCInputPreview';
import FeedbackInputPreview from './FeedbackInputPreview';
import { ICanvasElement } from '@/interface/canvas';
import { getScreenElementStyle } from '@/util/canvas';

const LeadInfoInputPreview = ({
  placeholder,
  name,
  value,
  type,
  element,
  error,
  label,
  onChange,
  setFieldValue,
  countryCode,
  termsAndConditionUrl,
  isTandCChecked,
  onTandCChecked,
}: LeadInfoInputPreviewProps) => {
  const style = getScreenElementStyle(element);
  useEffect(() => {
    const input: any = document.getElementById(name);
    if (input) {
      input.style.setProperty('--placeholder-color', style.color || 'gray');
      input.style.color = style.color || 'gray';
    }
  }, [style.color]);

  return (
    <>
      {name === 'feedback' ? (
        <FeedbackInputPreview
          value={value}
          title={label}
          style={style}
          onSelect={val => setFieldValue('feedback', val)}
        />
      ) : (
        <div id="lead_form_input" className="absolute z-[1]">
          {name == 'mobile_number' ? (
            <div
              style={{
                ...style,

                zIndex: 3,
              }}
            >
              <MobileInput
                code={countryCode}
                style={style}
                setFieldValue={setFieldValue}
              />
            </div>
          ) : name == 'termsAndCondition' ? (
            <TandCInputPreview
              style={style}
              text={label || ''}
              tandcUri={termsAndConditionUrl || ''}
              isChecked={isTandCChecked}
              onChecked={onTandCChecked}
            />
          ) : (
            <input
              placeholder={placeholder}
              type={type}
              id={name}
              name={name}
              value={value}
              onChange={onChange}
              style={style}
              className={`w-full lead_form_input h-[2.5rem] text-inherit px-4 bg-[transparent]  text-[gray]`}
            />
          )}
        </div>
      )}
      {error && (
        <div
          className="text-[8px] text-[#ff304f] absolute"
          style={{
            top: `calc(${style.top} + ${style.height})`,
            left: style.left,
          }}
        >
          {name === 'privacy_policy' ? 'Accept Privacy Policy' : <>{error}</>}
        </div>
      )}
    </>
  );
};

type LeadInfoInputPreviewProps = {
  placeholder: string;
  value: string;
  name: string;
  type: string;
  error?: any;
  label?: string;
  element: ICanvasElement;
  onChange: any;
  setFieldValue: any;
  countryCode?: string;
  termsAndConditionUrl?: string;
  isTandCChecked: boolean;
  onTandCChecked: () => void;
};

export default LeadInfoInputPreview;
